<div class="container-fluid pb-3 d-flex flex-column h-100">
  <div class="page-head">
    <h1 class="page-title">Admin - My Company</h1>
  </div>
  <p class="text-secondary mb-4">
    If you would like to update the information below, please contact
    <a href="mailto:support@getvived.com">support&#64;getvived.com</a> or
    contact customer support at 1-844-476-8038.
  </p>
  <app-add-edit-client></app-add-edit-client>
</div>
